var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`logo_tesla`, _vm.className || ``]},[_c('img',{staticClass:"logo_tesla-1",attrs:{"src":_vm.src,"alt":"logo_tesla 1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }